import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

function id(store, key) {
  let v = store.getItem(key);
  if (!v) { v = Math.random().toString(36).slice(2) + Date.now().toString(36); store.setItem(key, v); }
  return v;
}

export function useTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(search);
    api.post("/track", {
      path: pathname, referrer: document.referrer || "", lang: localStorage.getItem("cpenz_lang") || navigator.language || "",
      visitor_id: id(localStorage, "cpenz_vid"), session_id: id(sessionStorage, "cpenz_sid"), screen_w: window.innerWidth,
      utm_source: params.get("utm_source") || "",
    }).catch(() => {});
  }, [pathname, search]);
}
